// Radar State - Technology Radar navigation badge persistence
import { effect, signal } from '@preact/signals'
import { safeLocal } from '../utils/safeStorage.js'

/**
 * Tracks whether the user has seen the Technology Radar for the first time.
 * Used to show/hide the "New" badge on the Technology Radar nav tab.
 * Persisted to localStorage so the badge only shows until first visit.
 */
export const radarNewBadgeSeen = signal(
  safeLocal.get('batemo:radarNewBadgeSeen') === 'true'
)

/**
 * Dismiss the "New" badge on the Technology Radar tab.
 * Call this when the user visits /radar for the first time.
 */
export function dismissRadarNewBadge() {
  radarNewBadgeSeen.value = true
}

// Persist badge state to localStorage
effect(() => {
  safeLocal.set('batemo:radarNewBadgeSeen', String(radarNewBadgeSeen.value))
})

/**
 * Active plot index for radar section page (viewport-contained single-plot navigation)
 */
export const radarActivePlotIndex = signal(0)

/**
 * Total plot count for the current section (set by RadarSectionPage on load)
 */
export const radarActivePlotCount = signal(0)

/**
 * Export action signal — set by UnifiedContextBar, consumed by RadarSectionPage.
 * Values: null | 'png' | 'pptx-slide' | 'pptx-section'
 */
export const radarExportAction = signal(null)
